import React, { useEffect, useState } from 'react'
import { Box, Button, CircularProgress, Grid, Modal, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { getBeatChangeRequests } from '_controllers/officer';
import VisibilityIcon from '@mui/icons-material/Visibility';
import authAxios from 'setups/axios';
import AccessController from "_shared/AccessController";
import { DashGridL2 } from 'layouts/dash-grid';
import TopBar from '_shared/Top';
import { Toaster } from 'react-hot-toast';

const Main = () => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [open, setOpen] = useState(false);

    useEffect(async () => {
        // console.log("ft", SAP_ID)
        const plan = await getBeatChangeRequests();
        console.log("first", plan?.pjps)
        setData(plan?.pjps);
        setLoading(true);
    }, [message]);

    const handleApprove = async (action, id, SAP_ID) => {
        console.log("huhu", action, id, SAP_ID);
        const data = {
            action,
            beatId: id,
            SAP_ID
        }
        const response = await authAxios()({
            url: `/api/v1/pjp/beat/switch/action`,
            method: "PUT",
            data
        });
        console.log({ RES2: response?.data });
        setMessage(response?.message);
    };

    const handleRevert = async (action, id, SAP_ID) => {
        const data = {
            action,
            beatId: id,
            SAP_ID
        }
        const response = await authAxios()({
            url: `/api/v1/pjp/beat/switch/action`,
            method: "PUT",
            data
        });
        console.log({ RES: response?.data });
        setMessage(response?.message);
    };

    const approvedStyle = {
        color: 'green',
        fontWeight: "bolder"
    }
    const normalStyle = { fontWeight: "bolder" }

    const revertedStyle = {
        color: "red",
        fontWeight: "bolder"
    }

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <>
            {loading ? (
                <>
                    <TableContainer component={Paper} sx={{ mb: 2.5 }}>
                        <Table>
                            <TableHead >
                                <TableRow >
                                    <TableCell align="left" sx={{ fontWeight: 'bolder' }}>SAP_ID</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Status</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Activity</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Plan Date</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Switch Date</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Details</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Approve</TableCell>
                                    <TableCell align="center" sx={{ fontWeight: 'bolder' }}>Revert</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data && data?.length > 0
                                    ? data?.map((d) => (
                                        <TableRow key={d._id}>
                                            <TableCell align="left">{d?.SAP_ID}</TableCell>
                                            <TableCell align="center" style={d.status === "Approved" ? approvedStyle : (d?.status === "Reverted" ? revertedStyle : normalStyle)}>{d?.status}</TableCell>
                                            <TableCell align="center">{d?.activity}</TableCell>
                                            <TableCell align="center">
                                                {new Date(d?.planDate).toDateString()}
                                            </TableCell>
                                            <TableCell align="center">
                                                {new Date(d?.switchDate).toDateString()}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ cursor: "pointer" }}
                                            // onClick={() => {
                                            //   setOpen(true);
                                            //   setBeats(d?.beats);
                                            //   setDealers(d?.dealers);
                                            // }}
                                            >
                                                <VisibilityIcon
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => setOpen(true)}
                                                />
                                            </TableCell>
                                            <TableCell align="center">
                                                {d.status === "In-Review" ? (
                                                    <Button onClick={() => handleApprove("approve", d._id, d.SAP_ID)} variant='contained'>Approve</Button>
                                                ) : (
                                                    "-"
                                                )}
                                            </TableCell>
                                            <TableCell align="center">
                                                {d.status === "In-Review" ? (
                                                    <Button onClick={() => handleRevert("reject", d._id, d.SAP_ID)} variant='contained' color="error">Revert</Button>
                                                ) : (
                                                    "-"
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                    : <Box sx={{ textAlign: 'left', pt: 1 }}>
                                        <Typography variant="h6" sx={{ p: 1 }}>No Switch Request Avilable.</Typography>
                                    </Box>}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            ) : (
                <CircularProgress />
            )
            }
        </>
    );
};

const SwitchBeat = () => {
    return (
        <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
            <DashGridL2 Top={TopBar} Main={Main} />
            <Toaster />
        </AccessController>
    );
};

export default SwitchBeat;